var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "mt-10" }, [
    _c(
      "div",
      { staticClass: "bg-white shadow px-4 py-5 sm:rounded-lg sm:p-6" },
      [
        _c("div", { staticClass: "md:grid md:grid-cols-3 md:gap-6" }, [
          _vm._m(0),
          _vm.config.additionalAbandonedCartReminder
            ? _c("div", { staticClass: "mt-5 md:mt-0 md:col-span-2" }, [
                _c("form", { on: { submit: _vm.handleSubmit } }, [
                  _c("fieldset", [
                    _c(
                      "legend",
                      {
                        staticClass:
                          "text-base leading-6 font-medium text-gray-900"
                      },
                      [_vm._v(" Enable automation ")]
                    ),
                    _c(
                      "div",
                      { staticClass: "mt-4 flex flex-wrap" },
                      [
                        _c("VSwitch", {
                          attrs: {
                            value:
                              _vm.config.additionalAbandonedCartReminder
                                .isEnabled
                          },
                          on: { input: _vm.handleSwitch }
                        })
                      ],
                      1
                    ),
                    _c("p", { staticClass: "mt-2 text-sm text-gray-500" }, [
                      _vm._v(
                        " Automated WhatsApp messages are sent from our approved WhatsApp Business API number. "
                      )
                    ])
                  ]),
                  _c("div", { staticClass: "grid grid-cols-3 gap-6 mt-5" }, [
                    _c("div", { staticClass: "col-span-3 sm:col-span-2" }, [
                      _c("div", [
                        _c(
                          "label",
                          {
                            staticClass:
                              "block text-sm font-medium leading-5 text-gray-700",
                            attrs: { for: "phone_number" }
                          },
                          [_vm._v(" Phone Number ")]
                        ),
                        _c(
                          "div",
                          { staticClass: "mt-1 relative rounded-md shadow-sm" },
                          [
                            _c("vue-tel-input", {
                              attrs: {
                                value: _vm.phoneNumber,
                                mode: "international"
                              },
                              on: { input: _vm.handlePhoneNumberUpdate }
                            }),
                            _c(
                              "p",
                              { staticClass: "mt-2 text-sm text-gray-500" },
                              [
                                _vm._v(
                                  " We will share this number as a link where customers can reply to you if they have any concerns. "
                                )
                              ]
                            )
                          ],
                          1
                        )
                      ])
                    ])
                  ]),
                  _c("div", { staticClass: "col-span-3 sm:col-span-2" }, [
                    _c("div", [
                      _c(
                        "label",
                        {
                          staticClass:
                            "block text-sm font-medium text-gray-700",
                          attrs: { for: "company-website" }
                        },
                        [_vm._v(" Abandoned cart timing ")]
                      ),
                      _c(
                        "div",
                        { staticClass: "mt-1 flex rounded-md shadow-sm" },
                        [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value:
                                  _vm.config.additionalAbandonedCartReminder
                                    .sendAfterHours,
                                expression:
                                  "\n                    config.additionalAbandonedCartReminder.sendAfterHours\n                  "
                              }
                            ],
                            staticClass:
                              "flex-1 min-w-0 block w-full px-3 py-2 rounded-none rounded-l-md focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm border-gray-300 border",
                            attrs: {
                              type: "number",
                              name: "company-website",
                              id: "company-website",
                              placeholder: "number between 1 - 24"
                            },
                            domProps: {
                              value:
                                _vm.config.additionalAbandonedCartReminder
                                  .sendAfterHours
                            },
                            on: {
                              input: function($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.$set(
                                  _vm.config.additionalAbandonedCartReminder,
                                  "sendAfterHours",
                                  $event.target.value
                                )
                              }
                            }
                          }),
                          _c(
                            "div",
                            {
                              staticClass:
                                "inline-flex items-center px-3 rounded-r-md border border-l-0 border-gray-300 bg-gray-50 text-gray-500 sm:text-sm"
                            },
                            [_vm._v(" Hours after checkout abandoned ")]
                          )
                        ]
                      )
                    ])
                  ]),
                  _c("div", { staticClass: "grid grid-cols-3 gap-6 mt-5" }, [
                    _c("div", { staticClass: "col-span-3 sm:col-span-2" }, [
                      _c(
                        "label",
                        {
                          staticClass:
                            "block text-sm leading-5 font-medium text-gray-700",
                          attrs: { for: "location" }
                        },
                        [_vm._v("Language")]
                      ),
                      _c(
                        "select",
                        {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.config.messageLanguage,
                              expression: "config.messageLanguage"
                            }
                          ],
                          staticClass:
                            "mt-1 form-select block w-full pl-3 pr-10 py-2 text-base leading-6 border-gray-300 focus:outline-none focus:shadow-outline-blue focus:border-blue-300 sm:text-sm sm:leading-5",
                          attrs: { id: "location" },
                          on: {
                            change: function($event) {
                              var $$selectedVal = Array.prototype.filter
                                .call($event.target.options, function(o) {
                                  return o.selected
                                })
                                .map(function(o) {
                                  var val = "_value" in o ? o._value : o.value
                                  return val
                                })
                              _vm.$set(
                                _vm.config,
                                "messageLanguage",
                                $event.target.multiple
                                  ? $$selectedVal
                                  : $$selectedVal[0]
                              )
                            }
                          }
                        },
                        _vm._l(_vm.templates, function(language, index) {
                          return _c(
                            "option",
                            {
                              key: index,
                              domProps: { value: language.elementName }
                            },
                            [_vm._v(_vm._s(language.name))]
                          )
                        }),
                        0
                      )
                    ])
                  ]),
                  _c("div", { staticClass: "mt-6" }, [
                    _c(
                      "label",
                      {
                        staticClass:
                          "block text-sm leading-5 font-medium text-gray-700",
                        attrs: { for: "about" }
                      },
                      [_vm._v(" Message ")]
                    ),
                    _c("div", { staticClass: "rounded-md shadow-sm" }, [
                      _c("textarea", {
                        staticClass:
                          "form-textarea mt-1 block w-full transition duration-150 ease-in-out sm:text-sm sm:leading-5 cursor-not-allowed bg-gray-100",
                        attrs: { id: "about", rows: "8", disabled: true },
                        domProps: { value: _vm.currentTemplate }
                      })
                    ])
                  ]),
                  _c("div", { staticClass: "mt-4 sm:mt-0 sm:col-span-2" }, [
                    _c("div", { staticClass: "max-w-lg mt-5" }, [
                      _c("div", { staticClass: "relative flex items-start" }, [
                        _c("div", { staticClass: "flex items-center h-5" }, [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.config.includeDiscountCoupon,
                                expression: "config.includeDiscountCoupon"
                              }
                            ],
                            staticClass:
                              "form-checkbox h-4 w-4 text-indigo-600 transition duration-150 ease-in-out",
                            attrs: { id: "comments", type: "checkbox" },
                            domProps: {
                              checked: Array.isArray(
                                _vm.config.includeDiscountCoupon
                              )
                                ? _vm._i(
                                    _vm.config.includeDiscountCoupon,
                                    null
                                  ) > -1
                                : _vm.config.includeDiscountCoupon
                            },
                            on: {
                              change: function($event) {
                                var $$a = _vm.config.includeDiscountCoupon,
                                  $$el = $event.target,
                                  $$c = $$el.checked ? true : false
                                if (Array.isArray($$a)) {
                                  var $$v = null,
                                    $$i = _vm._i($$a, $$v)
                                  if ($$el.checked) {
                                    $$i < 0 &&
                                      _vm.$set(
                                        _vm.config,
                                        "includeDiscountCoupon",
                                        $$a.concat([$$v])
                                      )
                                  } else {
                                    $$i > -1 &&
                                      _vm.$set(
                                        _vm.config,
                                        "includeDiscountCoupon",
                                        $$a
                                          .slice(0, $$i)
                                          .concat($$a.slice($$i + 1))
                                      )
                                  }
                                } else {
                                  _vm.$set(
                                    _vm.config,
                                    "includeDiscountCoupon",
                                    $$c
                                  )
                                }
                              }
                            }
                          })
                        ]),
                        _c("div", { staticClass: "ml-3 text-sm leading-5" }, [
                          _c(
                            "label",
                            {
                              staticClass: "font-medium text-gray-700",
                              attrs: { for: "comments" }
                            },
                            [_vm._v("Include coupon code")]
                          ),
                          _c(
                            "div",
                            {
                              staticClass:
                                "sm:grid sm:grid-cols-3 sm:gap-4 sm:items-start  sm:pt-5"
                            },
                            [
                              _c("div", { staticClass: "sm:col-span-3" }, [
                                _c(
                                  "label",
                                  {
                                    staticClass:
                                      "block text-sm font-medium leading-5 text-gray-700",
                                    attrs: { for: "first_name" }
                                  },
                                  [_vm._v(" Coupon code ")]
                                ),
                                _c(
                                  "div",
                                  { staticClass: "mt-1 rounded-md shadow-sm" },
                                  [
                                    _c("input", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: _vm.config.couponCode,
                                          expression: "config.couponCode"
                                        }
                                      ],
                                      staticClass:
                                        "form-input block w-full transition duration-150 ease-in-out sm:text-sm sm:leading-5",
                                      attrs: {
                                        id: "first_name",
                                        placeholder: "10OFFNEW"
                                      },
                                      domProps: {
                                        value: _vm.config.couponCode
                                      },
                                      on: {
                                        input: function($event) {
                                          if ($event.target.composing) {
                                            return
                                          }
                                          _vm.$set(
                                            _vm.config,
                                            "couponCode",
                                            $event.target.value
                                          )
                                        }
                                      }
                                    }),
                                    _c(
                                      "p",
                                      {
                                        staticClass:
                                          "mt-2 text-sm text-gray-500"
                                      },
                                      [
                                        _vm._v(
                                          " Create coupon codes from your "
                                        ),
                                        _c(
                                          "a",
                                          {
                                            staticClass: "text-blue-700",
                                            attrs: {
                                              href: _vm.discountUrl,
                                              target: "_blank"
                                            }
                                          },
                                          [_vm._v("Shopify admin > Discounts")]
                                        )
                                      ]
                                    )
                                  ]
                                )
                              ])
                            ]
                          )
                        ])
                      ])
                    ]),
                    _c(
                      "div",
                      { staticClass: "mt-8 border-t border-gray-200 pt-5" },
                      [
                        _c("div", { staticClass: "flex justify-end" }, [
                          _c(
                            "span",
                            {
                              staticClass:
                                "ml-3 inline-flex rounded-md shadow-sm"
                            },
                            [
                              _c(
                                "button",
                                {
                                  staticClass:
                                    "inline-flex justify-center py-2 px-4 border border-transparent text-sm leading-5 font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-500 focus:outline-none focus:border-indigo-700 focus:shadow-outline-indigo active:bg-indigo-700 transition duration-150 ease-in-out",
                                  attrs: { type: "submit" },
                                  on: { click: _vm.save }
                                },
                                [_vm._v(" Save ")]
                              )
                            ]
                          )
                        ])
                      ]
                    )
                  ])
                ])
              ])
            : _vm._e()
        ]),
        _c("Notification", {
          attrs: { text: _vm.notificationText, show: _vm.showNotification }
        }),
        _vm.showModal
          ? _c("OptinOnboardingModal", {
              on: {
                close: function($event) {
                  _vm.showModal = false
                }
              }
            })
          : _vm._e()
      ],
      1
    ),
    _c("div", { staticClass: "bg-white shadow sm:rounded-lg my-5" }, [
      _c("div", { staticClass: "px-4 py-5 sm:p-6" }, [
        _c(
          "h3",
          { staticClass: "text-lg leading-6 font-medium text-gray-900" },
          [
            _vm._v(
              " Recover more sales by collecting WhatsApp opt-in from Checkout page (Mandatory) "
            )
          ]
        ),
        _c(
          "div",
          { staticClass: "mt-2 sm:flex sm:items-start sm:justify-between" },
          [
            _vm._m(1),
            _c(
              "div",
              {
                staticClass:
                  "mt-5 sm:mt-0 sm:ml-6 sm:flex-shrink-0 sm:flex sm:items-center"
              },
              [
                _c(
                  "span",
                  { staticClass: "inline-flex rounded-md shadow-sm" },
                  [
                    _c(
                      "button",
                      {
                        staticClass:
                          "inline-flex items-center px-4 py-2 border border-transparent text-sm leading-5 font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-500 focus:outline-none focus:border-indigo-700 focus:shadow-outline-indigo active:bg-indigo-700 transition ease-in-out duration-150",
                        attrs: { type: "button" },
                        on: { click: _vm.openOptinModal }
                      },
                      [_vm._v(" View guide ")]
                    )
                  ]
                )
              ]
            )
          ]
        )
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "md:col-span-1" }, [
      _c("h3", { staticClass: "text-lg font-medium leading-6 text-gray-900" }, [
        _vm._v(" Automated abandoned cart messages ")
      ]),
      _c("p", { staticClass: "mt-1 text-sm leading-5 text-gray-500" }, [
        _vm._v(" Configure whatsapp by adding your number ")
      ]),
      _c("div")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "max-w-xl text-sm leading-5 text-gray-500" },
      [
        _c("p", [
          _vm._v(
            " Complete the steps in the guide and apply for approval. We will manually check your store checkout page to verify the changes. "
          )
        ])
      ]
    )
  }
]
render._withStripped = true

export { render, staticRenderFns }